import { render } from "./mobile-risk-disclaimer.vue?vue&type=template&id=30efdff4"
const script = {}

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__